﻿window.vaneck = window.vaneck || {};

window.vaneck.membership = {
    drawRequiredMark: function (rightSide) {
        $('.Form__Element .ValidationRequired').each(function () {
            var caption = $(this).find('.Form__Element__Caption');
            if (caption.length == 0) {
                var elementLabels = $(this).find('label');
                if (elementLabels.length == 1) {
                    $(elementLabels[0]).prepend("<span class='RequiredAsterisk'>*</span>");
                }
            } else {
                if (rightSide) {
                    caption.append("<span class='RequiredAsterisk RightSide'>*</span>");
                } else {
                    caption.prepend("<span class='RequiredAsterisk'>*</span>");
                }
            }
        });
    },

    getMicrosite: function () {
        var segments = window.location.pathname.toLocaleLowerCase().split('/');

        var countryCodes = [
            { name: "us", countries: ["us"] },
            { name: "corp", countries: ["ca", "cl", "cn", "pe", "asia", "corp"] }
        ];

        var micrositeId = "ucits";

        countryCodes.forEach(function (e) {
            if (e.countries.includes(segments[1]))
                micrositeId = e.name;
        });

        return micrositeId;
    },

    getSubscriptionsJsonResultsUrl: function () {

        var micrositeId = vaneck.membership.getMicrosite();

        var urls = {
            'us': '/common/SubscriptionsElementData/GetSubscriptions',
            'ucits': '/common/SubscriptionsElementData/GetSubscriptions',
            'corp': '/common/SubscriptionsElementData/GetSubscriptions'
        };

        return urls[micrositeId];
    },

    fillSubscriptionCheckboxes: function () {
        return $.post(vaneck.membership.getSubscriptionsJsonResultsUrl(),
            {
                marketoId: $('input#RecordMarketoId[type="hidden"]').val(),
                sfveclid: $('input#RecordContactId[type="hidden"]').val(),
                siteContextType: $('#hdnCurrentSiteContextType').val(),
                salesId: new URLSearchParams(window.location.search).get('salesid'),
                formType: 'manage'
            })
            .done(function (data) {
                if (data.Success) {
                    vaneck.membership.fillSubscriptionElementBody(data.Result);
                } else {
                    //window.location.href = data.RedirectUrl;
                }
            });
    },

    fillSubscriptionElementBody: function (data) {
        var elementName = $('#email_subscriptions').data('form-element-name');
        $('#email_subscriptions .registration_body').html(data);
        $('#email_subscriptions .registration_body input').attr('name', elementName);
    },

    setValueByFriendlyName: function (form, name, value) {
        var element = vaneck.epiforms.getForms().getElementByFriendlyName(form, name);
        if (element != null) {
            element.val(value);
        }
    },

    countrySelectChanged: function (countrySelect) {
        var val = countrySelect.val();

        var container = $('.js-state-container');
        var id = container.data('field-id');
        var name = container.data('f-element-name');
        var required = container.hasClass('ValidationRequired');

        $('.js-state').removeAttr('id');
        $('.js-state').removeAttr('name');
        $('.js-state').removeAttr('required');
        $('.js-state').removeAttr('data-f-datainput');
        hideStateControls($('.js-state'));

        switch (!val || val.toLowerCase()) {
            case 'us':
            case 'usa':
                showStateControl($('.js-us-state'), true);
                break;

            case 'ca':
            case 'can':
                showStateControl($('.js-canada-state'));
                break;

            default:
                showStateControl($('.js-others-state'));
                break;
        }

        function hideStateControls(controls) {
            controls.each(function() {
                if ($(this).parents('.dropdown').length) {
                    $(this).parents('.dropdown').hide();
                } else {
                    $(this).hide();
                }
            });
        }

        function showStateControl(control, customRequired) {
            control.attr('id', id);
            control.attr('name', name);
            control.attr('data-f-datainput', 'data-f-datainput');
            if (control.parents('.dropdown').length) {
                control.parents('.dropdown').show();
            } else {
                control.show();
            }

            if (required) {
                control.attr('required');
            }
            var captionElement = control.parents('.js-state-container').find('.Form__Element__Caption');
            captionElement.find('span.input-required').remove();
            if (customRequired) {
                captionElement.append('<span class="input-required">*</span>');
            }
        }
    },

    spinner: {},

    showSpinner: function (spinnerContainer) {
        vaneck.membership.spinner = doSpinnerBySelector(spinnerContainer, null);
    },

    hideSpinner: function (spinnerContainer) {
        stopSpinnerBySelector(vaneck.membership.spinner, spinnerContainer);
    },

    initializeSpinner: function (preventSpinnerOnSubmit) {
        if (!vaneck.epiforms || !vaneck.epiforms.isInitialized()) {
            return;
        }

        vaneck.epiforms.getForms().AsyncSubmit = true;

        if (!preventSpinnerOnSubmit) {
            vaneck.epiforms.$epiforms()('.js-aspnet-form').on('formsStartSubmitting',
                function (data) {
                    vaneck.membership.showSpinner(getSpinnerContainerSelector(data.target));
                });
        }

        vaneck.epiforms.$epiforms()('.js-aspnet-form').on('formsSubmittedError formsSubmitted',
            function (data) {
                vaneck.membership.hideSpinner(getSpinnerContainerSelector(data.target));
            });
    }
};
function checkAll(id) {
    $('.' + id).find(':checkbox').each(function () {
        $(this).prop('checked', true);
    });
}

function uncheckAll(id) {
    $('.' + id).find(':checkbox').each(function () {
        $(this).prop('checked', false);
    });
}
window.addEventListener("DOMContentLoaded", function() {
    if ($("a[href='#select-all']").length > 0) {
        $("a[href='#select-all']").click(function () {
            $("#email_subscriptions input[type='checkbox']").prop('checked', true);
            return false;
        });
    }

    if ($("a[href='#unselect-all']").length > 0) {
        $("a[href='#unselect-all']").click(function () {
            $("#email_subscriptions input[type='checkbox']").prop('checked', false);
            return false;
        });
    }
});
//To fill the placeholders for row...
window.addEventListener('load',function() {
    if (vaneck.membership.getMicrosite() != "corp") return;
	console.log("triggered");
	var currentLink = $("#Unsubscribe_All_Span > span > a").attr("href");
	var sfveclid = $("#RecordContactId").val();
	$("#Unsubscribe_All_Span > span > a").attr("href", currentLink + "?sfveclid=" + sfveclid);
    $("a.stayintheknowlink").attr("href", "/row/subscriptions/manage-your-subscriptions/thank-you?sfveclid=" + sfveclid);
});